export default __webpack_public_path__ + "static/media/tablet-full.cb89e3ca.svg";